/**
 * French (fr) translations for TablixJS
 */
export const frenchTranslations = {
  // General
  'general.loading': 'Chargement...',
  'general.error': 'Erreur',
  'general.noData': 'Aucune donnée disponible',
  'general.show': 'Afficher',
  'general.entries': 'entrées',
  'general.of': 'de',
  'general.to': 'à',
  'general.records': 'enregistrements',
  'general.perPage': 'par page',
  'general.showing': 'Affichage',
  'general.total': 'Total',
  'general.rows': 'lignes',

  // Search
  'search.placeholder': 'Rechercher...',
  'search.clear': 'Effacer la recherche',
  'search.noResults': 'Aucun résultat trouvé',
  'search.resultsFound': 'résultats trouvés',

  // Pagination
  'pagination.first': 'Premier',
  'pagination.previous': 'Précédent',
  'pagination.next': 'Suivant',
  'pagination.last': 'Dernier',
  'pagination.page': 'Page',
  'pagination.pageOf': 'Page {currentPage} sur {totalPages}',
  'pagination.showingRecords': 'Affichage de {startRow} à {endRow} sur {totalRows} enregistrements',
  'pagination.noRecords': 'Aucun enregistrement trouvé',
  'pagination.pageSize': 'Enregistrements par page',

  // Sorting
  'sort.sortAscending': 'Trier croissant',
  'sort.sortDescending': 'Trier décroissant',
  'sort.sortedAscending': 'Trié croissant',
  'sort.sortedDescending': 'Trié décroissant',
  'sort.notSorted': 'Non trié',
  'sort.clearSort': 'Effacer le tri',

  // Selection
  'selection.selectRow': 'Sélectionner la ligne',
  'selection.deselectRow': 'Désélectionner la ligne',
  'selection.selectAll': 'Tout sélectionner',
  'selection.deselectAll': 'Tout désélectionner',
  'selection.selectedCount': '{count} sélectionné(s)',
  'selection.selectAllVisible': 'Sélectionner toutes les lignes visibles',
  'selection.clearSelection': 'Effacer la sélection',

  // Filtering
  'filter.filter': 'Filtrer',
  'filter.clearFilter': 'Effacer le filtre',
  'filter.clearAllFilters': 'Effacer tous les filtres',
  'filter.applyFilter': 'Appliquer le filtre',
  'filter.filterBy': 'Filtrer par',
  'filter.filterColumn': 'Filtrer la colonne',
  'filter.filterByValue': 'Filtrer par valeur',
  'filter.filterByCondition': 'Filtrer par condition',
  'filter.searchValues': 'Rechercher des valeurs...',
  'filter.selectAll': 'Tout sélectionner',
  'filter.noValuesAvailable': 'Aucune valeur disponible',
  'filter.addCondition': 'Ajouter une condition',
  'filter.removeCondition': 'Supprimer la condition',
  'filter.value': 'Valeur',
  'filter.apply': 'Appliquer',
  'filter.clear': 'Effacer',
  'filter.cancel': 'Annuler',
  'filter.contains': 'Contient',
  'filter.startsWith': 'Commence par',
  'filter.endsWith': 'Se termine par',
  'filter.equals': 'Égal à',
  'filter.notEquals': 'Différent de',
  'filter.greaterThan': 'Supérieur à',
  'filter.lessThan': 'Inférieur à',
  'filter.greaterThanOrEqual': 'Supérieur ou égal à',
  'filter.lessThanOrEqual': 'Inférieur ou égal à',
  'filter.between': 'Entre',
  'filter.isEmpty': 'Est vide',
  'filter.isNotEmpty': 'N\'est pas vide',
  'filter.selectValues': 'Sélectionner les valeurs',
  'filter.noOptionsAvailable': 'Aucune option disponible',
  'filter.complexDataNotSupported': 'Le filtrage par valeur n\'est pas disponible pour les colonnes avec des données complexes. Utilisez le filtrage par condition à la place.',

  // Controls
  'controls.refresh': 'Actualiser les données',
  'controls.export': 'Exporter les données',
  'controls.settings': 'Paramètres',
  'controls.columns': 'Colonnes',
  'controls.showColumns': 'Afficher/Masquer les colonnes',

  // Virtual Scrolling
  'virtualScroll.loadingMoreRows': 'Chargement de plus de lignes...',
  'virtualScroll.scrollToTop': 'Faire défiler vers le haut',
  'virtualScroll.scrollToBottom': 'Faire défiler vers le bas',

  // Error Messages
  'error.loadingData': 'Échec du chargement des données',
  'error.networkError': 'Erreur réseau',
  'error.invalidData': 'Format de données invalide',
  'error.serverError': 'Erreur serveur',
  'error.timeout': 'Délai d\'attente dépassé',
  'error.unknown': 'Une erreur inconnue s\'est produite',
  'error.retry': 'Réessayer',

  // Data Types
  'dataType.string': 'Texte',
  'dataType.number': 'Nombre',
  'dataType.date': 'Date',
  'dataType.boolean': 'Booléen',
  'dataType.currency': 'Devise',
  'dataType.percentage': 'Pourcentage',

  // Accessibility
  'accessibility.table': 'Tableau de données',
  'accessibility.sortableColumn': 'Colonne triable',
  'accessibility.selectableRow': 'Ligne sélectionnable',
  'accessibility.rowSelected': 'Ligne sélectionnée',
  'accessibility.rowNotSelected': 'Ligne non sélectionnée',
  'accessibility.pageNavigation': 'Navigation des pages',
  'accessibility.searchInput': 'Rechercher dans les données du tableau',
  'accessibility.filterColumn': 'Filtrer la colonne',

  // Actions
  'action.apply': 'Appliquer',
  'action.cancel': 'Annuler',
  'action.close': 'Fermer',
  'action.save': 'Enregistrer',
  'action.reset': 'Réinitialiser',
  'action.ok': 'OK',
  'action.yes': 'Oui',
  'action.no': 'Non',

  // Time and Date
  'date.today': 'Aujourd\'hui',
  'date.yesterday': 'Hier',
  'date.thisWeek': 'Cette semaine',
  'date.lastWeek': 'La semaine dernière',
  'date.thisMonth': 'Ce mois-ci',
  'date.lastMonth': 'Le mois dernier',

  // Numbers and Formatting
  'format.currency.symbol': '€',
  'format.decimal.separator': ',',
  'format.thousand.separator': ' ',
  'format.percentage.symbol': '%'
};

export default frenchTranslations;
